module.exports = __webpack_public_path__ + "media/images/official/special_double_life_point_cost-17f8b9de6d3a8b793a3a348c3a58625b.jpg";